import { createFileRoute } from '@tanstack/react-router';

interface NewSigningRequestSearch {
  employeeId?: string;
}

export const Route = createFileRoute('/t/signing-requests/new')({
  // hideShell → AppShell (the only Breadcrumbs renderer) isn't mounted, so no
  // breadcrumb staticData is needed.
  staticData: {
    hideShell: true,
  },
  validateSearch: (search: Record<string, unknown>): NewSigningRequestSearch => ({
    employeeId: typeof search.employeeId === 'string' ? search.employeeId : undefined,
  }),
});
